import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchCategories,
  SearchCategoriesVariables
} from "./types/SearchCategories";

export const searchCategories = gql`
  ${pageInfoFragment}
  query SearchCategories(
    $after: String
    $first: Int!
    $query: String!
    $level: Int
    $storeType: StoreTypeEnum
  ) {
    search: categories(
      after: $after
      first: $first
      level: $level
      filter: { search: $query, storeType: $storeType }
    ) {
      edges {
        node {
          id
          name
          storeType
          code
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchCategories, SearchCategoriesVariables>(
  searchCategories
);
